import type { Organization } from '@rtkwlf/eloc';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useElocApi } from '../use-eloc-api';

export const getOrganizationsQueryKey = () => ['get-organizations'];

export const useOrganizations = (options?: UseQueryOptions<Organization[]>) => {
  const elocApi = useElocApi();

  return useQuery({
    queryFn: () => elocApi.getOrganizations(),
    queryKey: getOrganizationsQueryKey(),
    ...options,
  });
};
